<form name="TaxSectionForm" (ngSubmit)="Validate(TaxSectionForm)" #TaxSectionForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Tax Section</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1 pt-2">
                    <label>Financial Year</label>
                    <ng-select name="FinancialYear" [items]="FinancialYears" bindLabel="FinancialYear"
                        bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Detail.ESS_TaxFinancialYearID"
                        placeholder="Financial Year" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select financial year.
                    </div>
                </div>
                <!-- <div class="col-md-6 px-1 pt-2">
                    <label>Financial Year Start</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2024" id="FinancialYearStart"
                            name="FinancialYearStart" [(ngModel)]="Detail.YearStart" #FinancialYearStart="ngModel"
                            pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)" maxlength="4"
                            (change)="SetFinancialYearEnd()" required>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year start.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-1 pt-2">
                    <label>Financial Year End</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2025" id="FinancialYearEnd"
                            name="FinancialYearEnd" [(ngModel)]="Detail.YearEnd" #FinancialYearEnd="ngModel"
                            pattern="^[0-9]\d*$" maxlength="4" (keypress)="common.NumberOnly($event)" required disabled>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year end.
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-12 px-1 pt-2">
                    <label>Tax Sections</label>
                    <ng-select name="TaxSections" [items]="TaxSections" bindLabel="TaxSectionsLable"
                        bindValue="ESS_TaxSectionMasterID" [(ngModel)]="Detail.ESS_TaxSectionMasterID"
                        (change)="SetSectionDetail()" placeholder="Tax Sections" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select tax sections.
                    </div>
                </div>
                <div class="col-md-12 px-1 pt-2">
                    <label>Description</label>
                    <textarea type="text" class="form-control" placeholder="Ex. Description" id="Description"
                        name="Description" [(ngModel)]="Detail.Description" #Description="ngModel" maxlength="200"
                        disabled></textarea>
                    <div class="invalid-feedback">
                        Please enter description.
                    </div>
                </div>
                <!-- <div class="col-md-4 px-1 pt-2">
                    <label>Section Code</label>
                    <input type="text" class="form-control" placeholder="Ex. SEC001" id="SectionCode" name="SectionCode"
                        [(ngModel)]="Detail.SectionCode" #SectionCode="ngModel" disabled>
                    <div class="invalid-feedback">
                        Please enter section code.
                    </div>
                </div>
                <div class="col-md-8 px-1 pt-2">
                    <label>Section Name</label>
                    <input type="text" class="form-control" placeholder="Ex. Section" id="SectionName"
                        name="SectionName" [(ngModel)]="Detail.SectionName" #SectionName="ngModel" disabled>
                    <div class="invalid-feedback">
                        Please enter section name.
                    </div>
                </div> -->
                <div class="row mt-2">
                    <div class="col-md-6 px-1 pt-2">
                        <label class="form-check-label link-dark px-1 mb-2" ngbButtonLabel>
                            <input class="form-check-input" type="checkbox" [value]=true name='IsOldRegimeApplicable'
                                [(ngModel)]="Detail.IsOldRegimeApplicable">
                            Old Regime Applicable
                        </label>
                        <br />
                        <label>Max Limit</label>
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="IsOldMaxlimitapplicable">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="IsOldMaxlimitapplicable"
                                        name="IsOldMaxlimitapplicable" [(ngModel)]="Detail.IsOldMaxlimitapplicable"
                                        [disabled]="!Detail.IsOldRegimeApplicable">
                                </div>
                            </span>
                            <input type="text" class="form-control" placeholder="Ex. 1000" id="OldRegimeMaxAmount"
                                name="OldRegimeMaxAmount" [(ngModel)]="Detail.OldRegimeMaxAmount"
                                #OldRegimeMaxAmount="ngModel" pattern="^[0-9]\d*$"
                                (keypress)="common.NumberOnly($event)" maxlength="6"
                                [disabled]="!Detail.IsOldMaxlimitapplicable || !Detail.IsOldRegimeApplicable">
                            <div class="invalid-feedback">
                                Please enter max limit.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 px-1 pt-2">
                        <label class="form-check-label link-dark px-1 mb-2" ngbButtonLabel>
                            <input class="form-check-input" type="checkbox" [value]=true name='IsNewRegimeApplicable'
                                [(ngModel)]="Detail.IsNewRegimeApplicable">
                            New Regime Applicable
                        </label>
                        <br />
                        <label>Max Limit</label>
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="IsNewMaxlimitapplicable">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="IsNewMaxlimitapplicable"
                                        name="IsNewMaxlimitapplicable" [(ngModel)]="Detail.IsNewMaxlimitapplicable"
                                        [disabled]="!Detail.IsNewRegimeApplicable">
                                </div>
                            </span>
                            <input type="text" class="form-control" placeholder="Ex. 1000" id="NewRegimeMaxAmount"
                                name="NewRegimeMaxAmount" [(ngModel)]="Detail.NewRegimeMaxAmount"
                                #NewRegimeMaxAmount="ngModel" pattern="^[0-9]\d*$"
                                (keypress)="common.NumberOnly($event)" maxlength="6"
                                [disabled]="!Detail.IsNewMaxlimitapplicable || !Detail.IsNewRegimeApplicable">
                            <div class="invalid-feedback">
                                Please enter max limit.
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-md-4 px-1 pt-2">
                    <div class="row px-1">
                        <div class="col-md-12">
                            <label>Income Head</label>
                            <ng-select name="IncomeHead" [items]="IncomeHeads" bindLabel="Name" bindValue="value"
                                [(ngModel)]="Detail.IncomeHead" placeholder="Income Head" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please enter income head.
                            </div>
                        </div>
                        <div class="col-md-12 pt-2">
                            
                        </div>
                    </div>
                </div> -->
                <div class="col-md-8 px-1 pt-2">
                    <div class="row px-1">

                        <!-- <div class="col-md-12 pt-2 align-self-center">
                            <div class="btn-group btn-group-toggle" style="width: 100%;">
                                <label class="form-check-label link-dark px-1" style="margin-left: 5%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name='IsNewRegime'
                                        [(ngModel)]="Detail.IsNewRegime">
                                    New Regime
                                </label>
                                <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name='IsNewRegime'
                                        [(ngModel)]="Detail.IsNewRegime">
                                    Old Regime
                                </label>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button
                        *ngIf="(this.Detail.ESS_TaxSectionFYMasterID == 0  && this.common.PageRight.IsAdd) || (this.Detail.ESS_TaxSectionFYMasterID > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>